<template>
	<div>
		<van-dropdown-menu>
		  <van-dropdown-item v-model="projectId" :options="projects" @change="projectChange"/>
		</van-dropdown-menu>
		<div class="m-box-tip">
			<div class="empty-tip-box empty-tip"></div><div class="empty-tip-text">空置中</div>
			<div class="empty-tip-box part-tip"></div><div class="empty-tip-text">部分出租</div>
			<div class="empty-tip-box leasing-tip"></div><div class="empty-tip-text">部分出租</div>
			<div style="height: 15px;display: flex;align-items: center;justify-content: center;font-size: 12px;">
			  <div style="width: 10px;height: 10px;border-radius: 50%;background-color: orange;"></div>
			  <div style="height: 30px;line-height: 30px;margin-left: 5px;">即将到期</div>
			</div>
			<div style="height: 15px;display: flex;align-items: center;justify-content: center;font-size: 12px;">
			  <div style="width: 10px;height: 10px;border-radius: 50%;background-color: red;"></div>
			  <div style="height: 30px;line-height: 30px;margin-left: 5px;">已到期</div>
			</div>
		</div>
		<div style="display: flex;gap: 5px;">
			<div style="overflow-y: auto;margin-left: 10px;">
				<van-sidebar v-model="activeKey" @change="floorChange">
				  <van-sidebar-item :title="item.name" v-for="item in floors"/>
				</van-sidebar>
			</div>
			<div class="m-box">
				<div v-if="item.isLeasingResources == 1 && item.building_id == floorId" @click="openDrawer(item)" v-for="item in dataList" :class="'m-block'+(item.propertyArea == 0?' empty':(item.propertyArea<item.last_property_area?' part':' leasing'))">
					{{item.code}}
					<div v-if="item.comingTimeout > 0 && item.timeout == 0" style="width: 5px;height: 5px;border-radius: 50%;background-color: orange;position: absolute;margin-left: 50px;margin-bottom: -15px;"></div>
					<div v-if="item.timeout > 0" style="width: 5px;height: 5px;border-radius: 50%;background-color: red;position: absolute;margin-left: 50px;margin-bottom: -15px;"></div>
				</div>
			</div>	
		</div>
		<van-action-sheet v-model="show" :title="item.title">
			<div style="padding: 16px 16px 160px;">
				<h2>{{item.code}}</h2>
				<div style="background-color: #E9F9F8;height: 60px;border-radius: 5px;display: flex;gap: 50px;justify-content: center;align-items: center;margin-bottom: 10px;">
					<div style="display: flex;flex-direction: column;align-items: center;gap: 5px;">
						<div style="color: #999999;">出租面积(㎡)</div>
						<div style="color: #5C8F8A;font-weight: bold;">{{item.propertyArea}}</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;gap: 5px;">
						<div style="color: #999999;">空置面积(㎡)</div>
						<div style="color: #5C8F8A;font-weight: bold;">{{(item.last_property_area - item.propertyArea).toFixed(2)}}</div>
					</div>
				</div>
				
				<h5 >租赁信息</h5>
				<div v-for="contract in item.contracts" style="background-color: #FEF5F0;border-radius: 5px;padding: 10px;overflow-wrap: break-word;color: #999999;margin-bottom: 5px;">
					{{contract.bunk_code+"|"+contract.customer_name}}
				</div>
			</div>
		</van-action-sheet>
	</div>
</template>

<script>
import LeasingService from "@/api/wechat/LeasingService";
export default {
	data() {
		return {
			projectId: 0,
			projects: [],
			activeKey: 0,
			floors: [],
			dataList: [],
			floorId: '',
			show: false,
			item: {}
		}
	},
	components: {
	},
	mounted() {
	},
	created() {
		this.getProjects()
	},
	methods: {
		openDrawer(item){
			this.show = true
			
			this.item = item
		},
		projectChange(value){
			this.getFloor(value)
		},
		floorChange(index) {
			this.floorId = this.floors[index].id
			this.getLeasing(this.projectId, this.floors[index].id)
		},
		getProjects (){
			new LeasingService().getProjects().then(({data}) => {
				data.forEach(d=>{
					d.text = d.projectName
					d.value = d.id
				})
				this.projects = data
				this.projectId = data[0].id
				
				this.getFloor(this.projectId)
			});
		},
		getFloor(projectId){
			new LeasingService().getFloor(projectId).then(({data}) => {
				this.floors = data
				
				this.floorId = this.floors[0].id
				this.getLeasing(projectId, this.floorId)
			});
		},
		getLeasing(projectId, buildingId){
			new LeasingService().getLeasing(projectId, buildingId).then(({data}) => {
			  this.dataList = data
			});
		}
	}
}
</script>

<style scoped>
	.m-box{
		display: flex;
	    gap: 10px;
	    flex-wrap: wrap;
	    width: calc(100% - 110px); /* 修正calc语法 */
	    overflow-y: auto; /* 超出部分滚动 */
	    align-content: flex-start; /* 避免换行内容撑开 */
		padding-top: 15px;
	}
	.m-block{
	  display: flex;flex-direction: column;justify-content: center;gap: 3px;
	  width: 60px;height: 30px;border-radius: 4px;
	  box-sizing: border-box;border: 1px dashed #333333;
	  color:#333333;text-align: center;font-size: 12px;
	}
	.empty{/**空置**/
	}
	.part{/**部分出租**/
	  background: linear-gradient(to top, #C9E0A8 50%, #FFFFFF 50%);
	}
	.leasing{/**已出租**/
	  background-color: #C9E0A8;
	}
	
	.m-box-tip{
		display: flex;gap: 20px;flex-wrap: wrap;padding: 10px;
	}
	.empty-tip-box{
		width: 15px;
		height: 15px;
	}
	.empty-tip-text{
		height: 30px;
		line-height: 15px;
		text-align: center;
		color: #333333;
		font-size: 12px;
		margin-left: -15px;
	}
	.empty-tip{/**空置**/
		border: 1px solid #EFEFEF;
	}
	.part-tip{/**部分出租**/
		background: linear-gradient(to top, #C9E0A8 50%, #FFFFFF 50%);
		border: 1px solid #EFEFEF;
	}
	.leasing-tip{/**已出租**/
		background-color: #C9E0A8;
		border: 1px solid #EFEFEF;
	}
	
	.van-sidebar {
	    width: 90px !important;
	    background-color: #fff !important;
	    border-right: 0px solid #eeeeee !important;
	}
	
	.van-sidebar-item {
	    position: relative;
	    display: block;
	    box-sizing: border-box;
	    padding: 10px 12px;
	    overflow: hidden;
	    color: #323233;
	    font-size: 14px;
	    line-height: 20px;
	    background-color: #f7f8fa;
	    cursor: pointer;
	    -webkit-user-select: none;
	    user-select: none;
		/* border-bottom: 1px solid #eeeeee !important; */
	}
</style>